<template>
  <div class="mx-auto max-w-2xl">
    <!-- Warning Banner for Unmet Document Requirements -->
    <div
      v-if="hasUnmetRequirements"
      class="mb-6 rounded-md bg-yellow-50 border border-yellow-200 p-4"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-yellow-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1">
          <h3 class="text-sm font-medium text-yellow-800">Missing Documents</h3>
          <div class="mt-2 text-sm text-yellow-700">
            <p>
              Sign-off will be declined until all document requirements are met.
              Please check the Document Requirements section before submitting.
            </p>
          </div>
        </div>
      </div>
    </div>

    <form
      ref="form"
      action="/member_sign_offs"
      accept-charset="UTF-8"
      method="post"
    >
      <div class="stack-mt-12">
        <member-form-field
          v-for="field in form"
          @update:modelValue="fieldChange(field)"
          :key="field.id"
          :field="field"
          v-model="field.value"
        >
          forcerefresh
        </member-form-field>
      </div>

      <div class="mt-8 pt-5">
        <member-form-errors
          v-if="formHasErrors"
          :error-fields="errorFields"
        ></member-form-errors>

        <div class="flex justify-end">
          <button
            @click.prevent="submit"
            type="submit"
            class="button button-primary inline-block px-16 py-3"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MemberFormShared from "./MemberFormShared"
import MemberSignOffConditions from "./MemberSignOffConditions"
export default {
  mixins: [MemberFormShared, MemberSignOffConditions],
  props: {
    hasUnmetRequirements: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableName: "member_sign_off",
    }
  },
  methods: {
    fieldChange(field) {
      if (field.id === "member_id") {
        // Redirect to he current URL plus ?member_id=123. Turbo is not available.

        let url = new URL(window.location.href)
        url.searchParams.set("member_id", field.value)

        window.location = url
      }
    },
  },
}
</script>
